<template>
  <GuidesContainer
    v-if="items.length"
    :items="items"
    :title="title"
    :subtitle="subtitle"
  />
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { GuidesContainer } from '@experience/guides-container';
  import type { ApiGuide } from '@/features/articleContent/lib/articleComponents';

  interface Props {
    guides?: ApiGuide[];
    title?: string;
    subtitle?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    guides: () => [],
    title: '',
    subtitle: '',
  });

  /** Адаптер: пакет @experience/guides-container ожидает GuideSlide (camelCase). */
  const items = computed(() =>
    props.guides
      .map((guide) => {
        const guideId = Number(guide.id);
        if (!Number.isFinite(guideId)) {
          return null;
        }
        const firstName = guide.first_name?.trim() ?? '';
        const avatarUrl = guide.avatar_url?.trim() ?? '';
        const determination = guide.determination?.trim() ?? '';
        const description = guide.description?.trim() ?? '';
        const rating = Number(guide.rating ?? 0);
        const reviewCount = Number(guide.reviews_count ?? 0);

        return {
          id: guideId,
          firstName,
          avatarUrl,
          rating: Number.isFinite(rating) ? rating : 0,
          reviewCount: Number.isFinite(reviewCount) ? reviewCount : 0,
          description,
          determination,
        };
      })
      .filter((item): item is NonNullable<typeof item> => item !== null),
  );
</script>
